import { render, staticRenderFns } from "./CPoptip.vue?vue&type=template&id=552fafbc&scoped=true"
import script from "./CPoptip.vue?vue&type=script&lang=js"
export * from "./CPoptip.vue?vue&type=script&lang=js"
import style0 from "./CPoptip.vue?vue&type=style&index=0&id=552fafbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552fafbc",
  null
  
)

export default component.exports